export default __webpack_public_path__ + "static/media/white-to-blue.3ab2af6e.png";